import i18n from '../i18n';

export function i18nDisplay(value, { prefer = null } = {}) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    const lang = prefer || (i18n && i18n.language) || 'en';
    // exact match
    if (value[lang]) return value[lang];
    // try language prefix (e.g. "en-US" => "en")
    const langPrefix = lang.split('-')[0];
    if (value[langPrefix]) return value[langPrefix];
    // fallback to en/fr or first available
    if (value.en) return value.en;
    if (value.fr) return value.fr;
    const vals = Object.values(value);
    return vals.length ? String(vals[0]) : '';
  }
  return String(value);
}

export default i18nDisplay;
